import { has } from "shared/utils";
import { Cell } from "../Cell";
import { ReportStatusBadge } from "../ReportStatusBadge";
import { Verification } from "../../types";
import { useAuthContext } from "providers/Auth";
import { Applicant } from "types/application";
import { EmptyCellIcon } from "./components/EmptyCellIcon";

interface RentalApplicationCellProps {
  verification: Verification;
  applicant: Applicant;
}

export const RentalApplicationCell = ({
  verification,
  applicant
}: RentalApplicationCellProps) => {
  const { permissions } = useAuthContext();
  return (
    <>
      <Cell
        isDataCell
        className="relative"
        showRestrictedFlag={!permissions.canAccessReports.rentalApplication}
        isPermitted={permissions.canAccessReports.rentalApplication}
      >
        {has(verification.summary?.total_dependents) ? (
          verification.summary.total_dependents
        ) : (
          <EmptyCellIcon />
        )}
        <ReportStatusBadge verification={verification} applicant={applicant} />
      </Cell>
      <Cell
        isDataCell
        isPermitted={permissions.canAccessReports.rentalApplication}
      >
        {has(verification.summary?.total_vehicles) ? (
          verification.summary.total_vehicles
        ) : (
          <EmptyCellIcon />
        )}
      </Cell>
      <Cell
        isDataCell
        isPermitted={permissions.canAccessReports.rentalApplication}
      >
        {has(verification.summary?.total_pets) ? (
          verification.summary.total_pets
        ) : (
          <EmptyCellIcon />
        )}
      </Cell>
    </>
  );
};
